import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GlobalApiService, GlobalConstantsWebservice, GlobalFunctions, GlobalSessionData } from "globales-projekt-angular";
import { catchError, Observable, retry } from "rxjs";
import { UserDatenEingabe } from "../data/user/user-daten-eingabe.model";
import { Betrieb } from "../data/ws/betrieb.model";
import { Oberbegriff } from "../data/ws/oberbegriff.model";
import { Region } from "../data/ws/region.model";
import { RubrikBmel } from "../data/ws/rubrik-bmel";
import { Rubrik } from "../data/ws/rubrik.model";
import { ConstantsWebservice } from "../immutable/constants-webservice";

@Injectable({
    providedIn: 'root',
  })
  
  export class ApiService extends GlobalApiService {
   
/*
  postCSV(filesToUpload: FileList) : Observable<Betrieb[]> {
    let serviceUrl: string = ApiService.baseUrl + ConstantsWebservice.POST_WS_CSV_DATA;

    let formData: FormData = new FormData();

    for (let i = 0; i < filesToUpload.length; i++) {
      let file: File = filesToUpload[i];

      formData.append('uploadFile-' + i, file, file.name);
    }
  
    //formData.append('parameter-' + 0,  new Blob());

    return this.http.post<Betrieb[]>(serviceUrl,formData).pipe(retry(ConstantsWebservice.RETRY_VERSUCHE), catchError(Functions.handleError));
  }
*/

  postCsvDatenInhalt(
    body: string[][]
  ): Observable<UserDatenEingabe[]> {
    let serviceUrl: string =
    GlobalSessionData.baseUrl + ConstantsWebservice.POST_WS_CSV_DATEN_INHALT;
    return this.http
      .post<UserDatenEingabe[]>(serviceUrl, body)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }  

  postUserBetriebsdaten(userDatenEingabe : UserDatenEingabe[]) : Observable<Betrieb[]> {
    let serviceUrl: string = GlobalSessionData.baseUrl + ConstantsWebservice.POST_WS_USER_BETRIEBSDATEN;

    return this.http.post<Betrieb[]>(serviceUrl, userDatenEingabe).pipe(retry(GlobalConstantsWebservice.RETRY_VERSUCHE), catchError(GlobalFunctions.handleError));
  } 
 
  postPdfBetriebe(userDatenEingabe : UserDatenEingabe[]): Observable<Blob> {      
    let serviceUrl: string =
      GlobalSessionData.baseUrl + ConstantsWebservice.POST_WS_PDF_BETRIEBE;
    
      return this.http
      .post<Blob>(serviceUrl, userDatenEingabe, { responseType: 'blob' as 'json' })
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      ); 
  }

  getRubriken(): Observable<Rubrik[]>
  {
    let serviceUrl: string = GlobalSessionData.baseUrl + ConstantsWebservice.GET_WS_RUBRIKEN;
    return this.http.get<Rubrik[]>(serviceUrl, {params: new HttpParams({fromObject: null})}).pipe(retry(GlobalConstantsWebservice.RETRY_VERSUCHE), catchError(GlobalFunctions.handleError));
  }

  getOberbegriffe(): Observable<Oberbegriff[]>
  {
    let serviceUrl: string = GlobalSessionData.baseUrl + ConstantsWebservice.GET_WS_OBERBEGRIFFE;
    return this.http.get<Oberbegriff[]>(serviceUrl, {params: new HttpParams({fromObject: null})}).pipe(retry(GlobalConstantsWebservice.RETRY_VERSUCHE), catchError(GlobalFunctions.handleError));
  }

  getRegionen(): Observable<Region[]>
  {
    let serviceUrl: string = GlobalSessionData.baseUrl + ConstantsWebservice.GET_WS_REGIONEN;
    return this.http.get<Region[]>(serviceUrl, {params: new HttpParams({fromObject: null})}).pipe(retry(GlobalConstantsWebservice.RETRY_VERSUCHE), catchError(GlobalFunctions.handleError));
  }

  getBMELCodes(): Observable<RubrikBmel[]>
  {
    let serviceUrl: string = GlobalSessionData.baseUrl + ConstantsWebservice.GET_WS_BMEL_CODES;
    return this.http.get<RubrikBmel[]>(serviceUrl, {params: new HttpParams({fromObject: null})}).pipe(retry(GlobalConstantsWebservice.RETRY_VERSUCHE), catchError(GlobalFunctions.handleError));
  }  
 
  }